export default __webpack_public_path__ + "media/images/blueprint-5c00220f2691cc8fac591f24b2c21041.png";